export type ValidationResultDetails<T> = Map<keyof T, { isValid: boolean; message: React.ReactNode }>

class ValidationResults<T> {
  private details: ValidationResultDetails<T>

  public constructor(details: ValidationResultDetails<T>) {
    this.details = details
  }

  public isFormValid() {
    return !Array.from(this.details).some(([, { isValid }]) => !isValid)
  }

  public isFieldValid(key: keyof T): boolean {
    const fieldResult = this.details.get(key)
    return fieldResult?.isValid ?? false
  }

  public getFieldErrorMsg(key: keyof T): string {
    const fieldResult = this.details.get(key)
    return (fieldResult?.message ?? '') as string
  }
}

export default ValidationResults
